import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from './component/Sidebar';

const apiUrl = 'https://jojomarket.net/adminfood/api-footer.php';

const initialState = {
  fournisseur_infos: '',
  condition_infos: '',
  qui_somme_nous: '',
  faq: '',
  telephone: '',
  email: '',
  adresse: '',
  qui_ser: '',
};

function Footer() {
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const loadFooter = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await axios.get(apiUrl);
      if (response.data && response.data.data) {
        setFormData({
          ...initialState,
          ...response.data.data,
        });
      }
    } catch (err) {
      setError("Erreur lors du chargement des informations footer.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadFooter();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage('');
    setError('');
    try {
      const response = await axios.post(apiUrl, formData);
      if (response.data && response.data.status === 'success') {
        setMessage('Le footer a été mis à jour avec succès.');
        if (response.data.data) {
          setFormData({
            ...initialState,
            ...response.data.data,
          });
        }
      } else {
        setError(response.data.message || "Une erreur est survenue lors de l'enregistrement.");
      }
    } catch (err) {
      setError("Impossible d'enregistrer les modifications du footer.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <Sidebar />
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header pb-0">
                  <h5 className="mb-0">Configuration du footer</h5>
                  <p className="text-sm text-muted mb-0">
                    Modifiez les contenus affichés sur le site public : informations fournisseurs, conditions, FAQ et contacts.
                  </p>
                </div>
                <div className="card-body">
                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Chargement...</span>
                      </div>
                    </div>
                  ) : (
                    <form onSubmit={handleSubmit}>
                      {message && (
                        <div className="alert alert-success" role="alert">
                          {message}
                        </div>
                      )}
                      {error && (
                        <div className="alert alert-danger" role="alert">
                          {error}
                        </div>
                      )}

                      <div className="mb-4">
                        <label className="form-label fw-bold">Présentation</label>
                        <textarea
                          className="form-control"
                          rows="4"
                          name="qui_somme_nous"
                          value={formData.qui_somme_nous}
                          onChange={handleChange}
                          placeholder="Décrivez votre entreprise..."
                        />
                      </div>

                      <div className="mb-4">
                        <label className="form-label fw-bold">Conditions d&apos;utilisation</label>
                        <textarea
                          className="form-control"
                          rows="4"
                          name="condition_infos"
                          value={formData.condition_infos}
                          onChange={handleChange}
                          placeholder="Conditions générales d'utilisation..."
                        />
                      </div>

                      <div className="mb-4">
                        <label className="form-label fw-bold">Infos fournisseurs</label>
                        <textarea
                          className="form-control"
                          rows="4"
                          name="fournisseur_infos"
                          value={formData.fournisseur_infos}
                          onChange={handleChange}
                          placeholder="Comment devenir fournisseur..."
                        />
                      </div>

                      <div className="mb-4">
                        <label className="form-label fw-bold">FAQ</label>
                        <textarea
                          className="form-control"
                          rows="4"
                          name="faq"
                          value={formData.faq}
                          onChange={handleChange}
                          placeholder="Questions fréquentes..."
                        />
                      </div>

                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-bold">Téléphone</label>
                          <input
                            type="text"
                            className="form-control"
                            name="telephone"
                            value={formData.telephone}
                            onChange={handleChange}
                            placeholder="+227 88909090"
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-bold">Email</label>
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="contact@.net"
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <label className="form-label fw-bold">Adresse</label>
                          <input
                            type="text"
                            className="form-control"
                            name="adresse"
                            value={formData.adresse}
                            onChange={handleChange}
                            placeholder="Adresse physique"
                          />
                        </div>
                      </div>

                      <div className="mb-4">
                        <label className="form-label fw-bold">À qui s&apos;adresse la plateforme ?</label>
                        <textarea
                          className="form-control"
                          rows="3"
                          name="qui_ser"
                          value={formData.qui_ser}
                          onChange={handleChange}
                          placeholder="Décrivez votre clientèle principale..."
                        />
                      </div>

                      <div className="text-end">
                        <button type="button" className="btn btn-outline-secondary me-2" onClick={loadFooter} disabled={saving}>
                          Recharger
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={saving}>
                          {saving ? 'Enregistrement...' : 'Enregistrer'}
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Footer;


